import React, { useState, useEffect } from "react";
import supabase from "../../../../utils/supabase";
import useUserStore from "../../../../stores/user";
import { useT } from "../../../../stores/uiLang";
import { TD_T } from "../../../../i18n/teacherDashboard";

interface Class {
  id: string;
  name: string;
}

export interface FilterState {
  selectedClass: string;
}

interface GradeDistributionFiltersProps {
  onFiltersChange: (filters: FilterState) => void;
  title?: string;
}

const GradeDistributionFilters: React.FC<GradeDistributionFiltersProps> = ({
  onFiltersChange,
  title,
}) => {
  const t = useT(TD_T);
  const heading = title ?? t.gradeDistribution;
  const [selectedClass, setSelectedClass] = useState<string>("");
  const [classes, setClasses] = useState<Class[]>([]);

  const user = useUserStore((state) => state.user);

  // Fetch classes for the dropdown
  useEffect(() => {
    const fetchClasses = async () => {
      if (!user) return;

      const { data, error } = await supabase
        .from("classes")
        .select("id, name")
        .eq("user_id", user.id);

      if (error) {
        console.error("Error fetching classes:", error);
        return;
      }

      setClasses(data || []);
      
      if (data && data.length > 0 && !selectedClass) {
        setSelectedClass(data[0].id);
      }
    };

    fetchClasses();
  }, [user, selectedClass]);

  // Notify parent component when filters change
  useEffect(() => {
    onFiltersChange({
      selectedClass,
    });
  }, [selectedClass, onFiltersChange]);

  const handleClassChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const classId = e.target.value;
    setSelectedClass(classId);
  };

  return (
    <div className="flex justify-between items-center mb-5">
      <h2 className="text-lg font-medium primary-text">{heading}</h2>
      <div className="flex items-center space-x-4">
        {/* Class Dropdown */}
        <div className="relative">
          <select
            value={selectedClass}
            onChange={handleClassChange}
            className="rounded-md border border-gray-300 shadow-sm px-4 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 bg-white"
          >
            <option value="">{t.selectClass}</option>
            {classes.map((classItem) => (
              <option key={classItem.id} value={classItem.id}>
                {classItem.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default GradeDistributionFilters;
